// extracted by mini-css-extract-plugin
module.exports = {"spinner":"c6ww7__spinner","timer":"_2jD0d__timer","stopBtn":"_2OtJO__stopBtn"};